import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SendSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SendSVG;
